import { ButtonIcon, Flex } from "@backstage/ui";
import {
    RiCloseLine,
    RiCustomerServiceFill,
    RiFullscreenExitLine,
    RiFullscreenLine,
} from "@remixicon/react";

import styles from "./ChatPanel.module.css";

export interface ChatPanelHeaderProps {
    isMaximized: boolean;
    isMobile: boolean;
    onMaximize: () => void;
    onClose: () => void;
}

export const ChatPanelHeader = ({
    isMaximized,
    isMobile,
    onMaximize,
    onClose,
}: ChatPanelHeaderProps) => (
    <Flex align="center" gap="2" className={styles.header}>
        <RiCustomerServiceFill className={styles.headerIcon} />

        <Flex direction="column" gap="0.5" className={styles.headerText}>
            <span className={styles.headerTitle}>Docs ChatBot</span>
            <span className={styles.headerSubtitle}>
                Powered by{" "}
                <a
                    href="https://askjack.jackhenry.com/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className={styles.headerSubtitleLink}
                >
                    AskJack
                </a>
            </span>
        </Flex>

        {!isMobile && (
            <ButtonIcon
                aria-label={isMaximized ? "Restore size" : "Maximize chat"}
                icon={
                    isMaximized ? (
                        <RiFullscreenExitLine size={20} />
                    ) : (
                        <RiFullscreenLine size={20} />
                    )
                }
                onPress={onMaximize}
                variant="tertiary"
                className={styles.headerButton}
            />
        )}

        <ButtonIcon
            aria-label="Close chat"
            icon={<RiCloseLine size={20} />}
            onPress={onClose}
            variant="tertiary"
            className={styles.headerButton}
        />
    </Flex>
);
